;(function() {
  'use strict'

  siteService.$inject = ["$q", "opportunitiesResource"];
  tempResource.$inject = ["resourcesProvider"];
  angular
    .module('core.services')
    .config(tempResource)
    .factory('siteService', siteService)

  /* @ngInject */
  function siteService($q, opportunitiesResource) {
    return {
      enquire: enquire,
      newsletter: newsletter,
    }

    // --------------------

    function enquire(enquiry) {
      var data = {}
      data.businessName =
        'Company: ' + enquiry.company + '\n\nMessage: ' + enquiry.message
      data.firstName = enquiry.name
      data.phoneNumber = enquiry.phone
      data.email = enquiry.email

      return submitOpportunity(data)
    }

    function newsletter(info) {
      var data = {}
      data.businessName = 'USER NEWSLETTER SIGNUP'
      data.firstName = info.name
      data.email = info.email

      return submitOpportunity(data)
    }

    function submitOpportunity(data) {
      return $q(function(resolve, reject) {
        _.defaults(data, {
          businessAddress: ' ',
          businessCity: ' ',
          businessState: ' ',
          firstName: ' ',
          lastName: ' ',
          role: ' ',
          phoneNumber: ' ',
          email: ' ',
        })

        opportunitiesResource
          .create(data)
          .success(function() {
            console.log('resolve')
            resolve()
          })
          .error(function() {
            console.log('reject')
            reject()
          })
      })
    }
  }

  /* @ngInject */
  function tempResource(resourcesProvider) {
    resourcesProvider.create('opportunities', {
      url: '/opportunities',
      actions: {
        create: {
          method: 'POST',
        },
      },
    })
  }
})()
